import React from 'react';
import styled from '@emotion/styled';
import type { DisplayProps } from 'styled-system';
import { display } from 'styled-system';

import type { RRPPrice as RRPPriceType } from 'common/types/Article';
import { useLocalization } from '../../providers/LocaleProvider';
import { CaptionRegularCR1 } from '../Typography';

interface RRPPriceProps {
  rrpPrice: Pick<RRPPriceType, 'value'>;
  Typography?: typeof CaptionRegularCR1;
}

const Container = styled.div<DisplayProps>`
  ${display};
`;

const RRPPrice = ({ rrpPrice, Typography = CaptionRegularCR1, ...props }: RRPPriceProps) => {
  const { fc, r } = useLocalization();

  if (!rrpPrice?.value) {
    return null;
  }

  return (
    <Container display="inline-flex" {...props}>
      <Typography as="span" pr="sp_4" fontWeight="normal" data-testid="rrp-price">
        {r.t('h24_rrp_value', { rrp: fc(rrpPrice.value) })}
      </Typography>
    </Container>
  );
};

export default RRPPrice;
